import Vue from "vue";

export default new Vue({
	data() {
		return {
			key: "",
			events: [],
		};
	},
	methods: {
		trackEvent(event, callback) {
			const index = this.events.indexOf(event);
			if (0 > index) this.events.push(event);

			this.$on(event, callback);
		},
		async destroyEvents() {
			await this.events.forEach((event) => {
				this.$off(event);
			});
		},
	},
});
